var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCameraMember(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "9px",
    viewBox: "0 0 13 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCameraMember") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chatrooms_VideoMembers-Copy-5",
    transform: "translate(-61.000000, -173.000000)",
    fill: "#7EC34D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(13.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(48.000000, 144.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7169942,4.26006507 C12.6541322,4.23666907 12.5936841,4.22492181 12.535599,4.22492181 C12.4049966,4.22492181 12.2962967,4.26954661 12.2091691,4.35854994 L9.28560539,7.18518144 L9.28560539,6.02503509 C9.28560539,5.46715119 9.08126592,4.99026671 8.67258697,4.5941354 C8.26388262,4.19805334 7.77191285,4 7.19627113,4 L2.08923263,4 C1.51376877,4 1.02164654,4.19805334 0.612916781,4.5941354 C0.204339473,4.99026671 0,5.46715119 0,6.02503509 L0,10.9750388 C0,11.5328734 0.204339473,12.0097333 0.612942191,12.40584 C1.02167195,12.8019467 1.51379418,13 2.08925804,13 L7.19632194,13 C7.77193826,13 8.26393344,12.8019467 8.67263779,12.40584 C9.08131674,12.0097333 9.28565621,11.5328981 9.28565621,10.9750388 L9.28565621,9.80777514 L12.20922,12.6414254 C12.2963475,12.7304041 12.4050474,12.7750043 12.5356499,12.7750043 C12.5937349,12.7750043 12.654183,12.7632817 12.717045,12.7399349 C12.9057579,12.6602161 13,12.5219827 13,12.3251114 L13,4.6750117 C12.9999238,4.47804196 12.9056817,4.33978388 12.7169942,4.26006507 Z",
    id: "icCameraMember"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCameraMember);
export default __webpack_public_path__ + "static/media/icCameraMember.93e4ecf3ccaf5cc085f6b388051a5aa1.svg";
export { ForwardRef as ReactComponent };